import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

export const isPractitionerEditable = (practitioner: PractitionerView): boolean => {
   return (
      practitioner.jobPositions.includes('RECEPTIONIST') ||
      practitioner.jobPositions.includes('ADMIN') ||
      practitioner.jobPositions.includes('DOCTOR')
   );
};
